module.exports = __webpack_public_path__ + "img/qita.9a699fee.png";